<app-admin-navbar></app-admin-navbar>
<div class="admin-page">

  <h1>Add Product</h1>

  <input
    type="text"
    placeholder="Name"
    [(ngModel)]="product.name">

  <input
    type="text"
    placeholder="Slug"
    [(ngModel)]="product.slug">

  <textarea
    placeholder="Description"
    [(ngModel)]="product.description">
  </textarea>

    <select
      [(ngModel)]="product.categoryId"

      name="categoryId">

      <option
        [ngValue]="null">

        Select Category

      </option>

      <option
        *ngFor="
          let category
          of categories
        "

        [ngValue]="category.id">

        {{ category.name }}

      </option>

    </select>

  <input
    type="file"
    (change)="onFileSelected($event)">

  <img
    *ngIf="imagePreview"
    [src]="imagePreview"
    class="preview">

<button
  (click)="saveProduct()">

  SAVE PRODUCT

</button>

</div>